import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import SimpleToast from '../SimpleToast.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderCancelFailedToast',
  props: {
  errorCode: { type: String, required: false },
},
  emits: ["remove"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

const { te } = useI18n({ useScope: 'global' });

const reason = computed(() => {
  const tKey = `modules.myOrders.toasts.cancelled.reasons.${props.errorCode}`;

  return te(tKey) ? tKey : 'modules.myOrders.toasts.cancelled.failed';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SimpleToast, {
    variant: "failed",
    "icon-name": "danger",
    title: "fundamentals.toasts.failed",
    message: reason.value,
    onRemove: _cache[0] || (_cache[0] = ($event: any) => (emit('remove')))
  }, null, 8, ["message"]))
}
}

})